var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6998 2.58594C12.1915 2.58594 10.8415 3.31927 9.99984 4.44427C9.15817 3.31927 7.80817 2.58594 6.29984 2.58594C3.7415 2.58594 1.6665 4.66927 1.6665 7.24427C1.6665 8.23594 1.82484 9.1526 2.09984 10.0026C3.4165 14.1693 7.47484 16.6609 9.48317 17.3443C9.7665 17.4443 10.2332 17.4443 10.5165 17.3443C12.5248 16.6609 16.5832 14.1693 17.8998 10.0026C18.1748 9.1526 18.3332 8.23594 18.3332 7.24427C18.3332 4.66927 16.2582 2.58594 13.6998 2.58594Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPurple);
export default __webpack_public_path__ + "static/media/heart-purple.f062ffb769d30e56cbca82f506aba434.svg";
export { ForwardRef as ReactComponent };